import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-video',
  templateUrl: './video.component.html',
  styleUrls: ['./video.component.scss'],
})
export class VideoComponent implements OnInit {

    static componentName = 'VideoComponent';
    @Input()videoId: String;
    safeUrl: any;

    constructor(
        public sanitizer: DomSanitizer,
    ) {}

    ngOnInit() {
        this.safeUrl = this
            .sanitizer
            .bypassSecurityTrustResourceUrl('https://player.vimeo.com/video/' + this.videoId + '?color=fff&title=0&byline=0&portrait=0');
    }

}



// WEBPACK FOOTER //
// E:/MBP/BloomyNG/src/app/video/video.component.ts